import { useSelector } from 'react-redux'
import AydinlatmaMetniModal from '../components/modals/registerInformations/AydinlatmaMetni'
import UyelikSozlesmesiModal from '../components/modals/registerInformations/UyelikSozlesmesi'
import AcikRizaMetniModal from '../components/modals/registerInformations/AcikRizaMetni'
import VerificationCodeModal from '../components/modals/registerInformations/VerificationCode'
import RegisterResultModal from '../components/modals/registerInformations/RegisterResult'
import ForgotVerificationCodeModal from '../components/modals/forgotModals/ForgotVerificationCodeModal'
import ForgotResultModal from '../components/modals/forgotModals/ForgotResulModal'
import { setRegisterVerificationCodeTimer } from '../features/register/registerSlice'
import { useDispatch } from 'react-redux'
import { useEffect } from 'react'
import { setForgotPasswordVerificationCodeTimer } from '../features/auth/authSlice'

const RegisterModalLayout = () => {

    const {modalType, registerVerificationStatus, registerVerificationCodeTimer} = useSelector((state) => state.register)
    const {forgotPasswordVerificationStatus, forgotPasswordVerificationCodeTimer} = useSelector(state => state.auth)

    const dispatch = useDispatch()

    useEffect(() => {
      if(registerVerificationStatus){
        if (registerVerificationCodeTimer > 0) {
          const timerId = setInterval(() => {
            dispatch(setRegisterVerificationCodeTimer(registerVerificationCodeTimer - 1))
          }, 1000);
    
          return () => clearInterval(timerId); // Bileşen unmount olduğunda timer'ı temizler
        }
      }
    }, [registerVerificationCodeTimer, registerVerificationStatus]);


    useEffect(() => {
      if(forgotPasswordVerificationStatus){
        if (forgotPasswordVerificationCodeTimer > 0) {
          const timerId = setInterval(() => {
            dispatch(setForgotPasswordVerificationCodeTimer(forgotPasswordVerificationCodeTimer - 1))
          }, 1000);
    
          return () => clearInterval(timerId); // Bileşen unmount olduğunda timer'ı temizler
        }
      }
    }, [forgotPasswordVerificationCodeTimer, forgotPasswordVerificationStatus]);


  return (
    <>
        {modalType === "uyelikSozlesmesi" && <UyelikSozlesmesiModal />}
        {modalType === "aydinlatmaMetni" && <AydinlatmaMetniModal />}
        {modalType === "acikRizaMetni" && <AcikRizaMetniModal />}
        {modalType === "verificationCode" && <VerificationCodeModal />}
        {modalType === "forgotVerificationCode" && <ForgotVerificationCodeModal />}
        {modalType === "registerResult" && <RegisterResultModal />}
        {modalType === "forgotResult" && <ForgotResultModal />}
    </>
  )
}

export default RegisterModalLayout